import React, {useEffect, useState} from 'react';
import './style.scss';
import {Button, Col, Layout, Row} from "antd";
import {Content} from "antd/es/layout/layout";
import ProPortalHeader from "../../../componets/ProPortalHeader";
import ProfileRow from "../../../componets/ProfileRow";
import Navigator from "../../../componets/Navigator";
import {get_api, post_api} from "../../../serverTemp";
import Camera from './imgs/camera.svg';
import SparkMD5 from 'spark-md5';

const MainContent = () => {
    const [user, setUser] = useState({})
    const [newData, setNewData] = useState({
        id: localStorage.getItem('user_id'),
        avatar: '',
        email: '',
        nickname: '',
    });
    const [selectedImage, setSelectedImage] = useState(null); // 新增状态用于存储图片

    useEffect(() => {
        get_api('/user/detail').then(res => {
            console.log(res)
            setUser(res);
            setNewData(prevData => ({ ...prevData, avatar: res.avatar, email: res.email, nickname: res.nickname }));
        });
    }, []);
    const calculateFileMD5 = async (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            // 读取文件完成后触发的事件
            reader.onload = function(e) {
                const data = e.target.result;
                const md5 = SparkMD5.ArrayBuffer.hash(data); // 计算MD5
                resolve(md5);
            };

            reader.onerror = function(error) {
                reject(error);
            };

            // 以ArrayBuffer的形式读取文件内容，以便MD5库可以处理
            reader.readAsArrayBuffer(file);
        });
    };

    //新增函数用于处理文件选择
    const handleFileChange = async (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];

            try {
                const fileMD5 = await calculateFileMD5(file);
                const formData = new FormData();
                formData.append('file', file);

                const response = await fetch('http://192.168.1.140:8008/storage/store/file', {
                    method: 'POST',
                    headers: {
                        'Filename': file.name,
                        'IDcard': fileMD5,
                    },
                    body: formData,
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                console.log("Response URL:", data.url);
                setSelectedImage(URL.createObjectURL(file));
                setNewData(prevData => ({...prevData, avatar: data.url}));
            } catch (error) {
                console.error('Error uploading image:', error);
            }
        }
    };

    // 新增函数用于触发隐藏的文件输入
    const triggerFileInput = () => {
        document.getElementById('fileInput').click();
    };

    // 定义转换函数
    const getSubscriptionType = (subscription) => {
        const types = ["Standard", "Advanced", "Premium"];
        return types[subscription] || "Unknown";
    };
    const handleInputChange = (e) => {
        setNewData({...newData, [e.target.name]: e.target.value});
    };
    const saveChanges = async () => {
        console.log('Saving new data:', newData);

        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("X-Access-Token", "2312");

        var raw = JSON.stringify(newData);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        try {
            const response = await fetch("http://192.168.1.140:8007/user/update", requestOptions);

            if (!response.ok) {
                throw new Error('HTTP Error: ' + response.statusText);
            }

            const result = await response.json();

            if (result.code === 200) {
                window.alert('Success!');
                console.log('User data updated successfully');
            } else {
                window.alert('Server side error!');
                throw new Error('Server side error: ' + result.message);
            }
        } catch (error) {
            console.error('Error saving user data:', error);
        }
    };

    return (
        <Row gutter={16}>
            <Col span={12}>
                <p className='PortalAccountDetails-title'>Change your details</p>
                <div>
                    <div className="MD-form-group">
                        <label className='MD-form-group-label'>Account name</label><br/>
                        <input className='MD-form-group-input'
                               type="text"
                               name={'nickname'}
                               onChange={handleInputChange}
                        />
                    </div>
                    <div className="MD-form-group">
                        <label className='MD-form-group-label'>Email address</label><br/>
                        <input className='MD-form-group-input'
                               type="email"
                               name={'email'}
                               onChange={handleInputChange}
                        />
                    </div>
                    <div className="MD-form-group">
                        <label className='MD-form-group-label'>Subscription type</label><br/>
                        <input className='MD-form-group-select' placeholder={getSubscriptionType(user.subscription)} disabled></input>
                        {/*<p className='MD-form-group-text'>If you wish to change your subscription level, please contact us.</p>*/}
                    </div>
                </div>
                <p className='PortalAccountDetails-content'>
                    To learn more about our subscription plans or upgrade your current subscription,<br/>
                    please visit our <a href="./MyAccount" className="subscriptionLink">Subscription page</a> for detailed information.
                </p>
            </Col>
            <Col span={12}>
                <div className="profile-picture">
                    {/*<img src={selectedImage || Camera} alt="Profile" className="Camera-icon"/>*/}
                    <img src={selectedImage || Camera} alt="Profile"
                         className={`Camera-icon ${!selectedImage ? "default-icon" : ""}`}/>
                </div>
                <Button className='profile-picture-button' onClick={triggerFileInput}>
                    Update profile picture
                </Button>
                {/* 隐藏的文件输入 */}
                <input type="file" id="fileInput" style={{display: 'none'}} onChange={handleFileChange}/>
            </Col>
            <Button className="MD-Save-button" onClick={saveChanges}>Save changes</Button>
        </Row>
    )
};

const ChangeAccountDetails = () => {
    return (
        <Layout>
            <Content>
                <ProPortalHeader/>
                <ProfileRow/>
                <Row justify={"center"}>
                    <Layout>
                        <Navigator/>
                        <Layout>
                            <div className='ProAccountDetails'>
                                <p className='ProAccountDetails-title'>Hello Vieunite Ltd</p>
                                <MainContent/>
                            </div>
                        </Layout>
                    </Layout>
                </Row>
            </Content>
        </Layout>
    );
}

export default ChangeAccountDetails;